import { Badge } from '../../../components/core';
import { IconMoon } from '../../../components/icons/IconMoon';
import { getStylesheet } from '../../../styles';
import { ConnectNowAvailabilityStatuses, OfflineStatus } from '../connectNowTypes';

type OfflineBadgeProps = {
  type: OfflineStatus;
};

export const OfflineBadge = ({ type }: OfflineBadgeProps): JSX.Element => {
  const isHoliday = type === ConnectNowAvailabilityStatuses.Holiday;

  return (
    <Badge.warningSubtle {...styles.offlineBadge} leftIcon={<IconMoon aria-hidden />}>
      {isHoliday ? 'Offline for Holiday' : 'Currently Offline'}
    </Badge.warningSubtle>
  );
};

const styles = getStylesheet({
  offlineBadge: {
    alignSelf: 'center',
  },
});
